import DateText from 'components/inputs/date-text'
import DataTable_s from "components/table/data-table-styles"
import Isvg from "react-inlinesvg"
import styled from "styled-components"
import { Colors } from "styles/app-styles"
import { FormSection } from 'styles/form-styles'
import { InputBaseStyles } from 'styles/input-styles'

export const AssetList_s = styled.div`
  .p-paginator {
    bottom: 0px;
  }

  ${FormSection}{
    #propertyTypeInput {
      margin-bottom: 1em;
    }
  }
`
export const ValidationIcon_s = styled(Isvg)`
  cursor: pointer;
  path { fill: ${Colors.colorWarning}; }
`

export const AssetListTable_s = styled(DataTable_s)`
  border-spacing: 15px;
  margin-top: -5px;

  .p-datatable-frozen-view .p-datatable-scrollable-header-table {
    position: fixed;
    z-index: 90;
  }

  .p-datatable-scrollable-body-table {
    margin-top: 36px;
  }

  table.p-datatable-scrollable-header-table, table.p-datatable-scrollable-body-table {
    width: auto;
  }

  div.p-datatable-scrollable-view.p-datatable-frozen-view thead.p-datatable-thead tr:last-child {
    height: 41px;
  }

  th.p-filter-column > input, th.p-filter-column > div.p-dropdown {
    margin-bottom: 0;
    width: calc(100% - 8px);
  }

  // The following styles are to make sure the dropdowns filters on the unfrozen side of the table can overlay the table body //
  // Override from table styles
  .p-datatable-frozen-view .p-datatable-scrollable-header {
    position: unset !important;
    z-index: unset !important;
  }
  .p-datatable-scrollable-view.p-datatable-unfrozen-view {
    thead.p-datatable-thead {
      background: ${Colors.white};
      position: fixed;
      z-index: 1;
      th.p-editable-column:nth-child(2), th.p-editable-column:nth-child(4){
        position: fixed;
      }
    }
    .p-datatable-scrollable-body {
      margin-top: 5px;
    }
  }
  //////////////////////////////////////////////////////////////////////////

  thead > tr {
    th.p-filter-column:first-child {
      max-width: 45px;
    }
  }

  table.p-datatable-scrollable-body-table {
    box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
  }

  .p-datatable-thead > tr {
    height: 30px;
  }

  td.asset-name > span {
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .property-type-column svg {
    width: 16px;
    margin-left: 5px;
    vertical-align: middle;
    &.mf-icon {
      margin-left: 6px;
      width: 14px;
    }
    .r-svg {
      fill: ${Colors.blackPearl};
    }
  }
`

export const AddAssetModal_s = styled.div`
  display: flex;
  flex-direction: column;
  > div {
    display: flex;
    flex-direction: column;
    > input, > span {
      margin: 10px 0;
    }
  }
  > div:last-child {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 20px;
  }
`

export const DateText_s = styled(DateText)`
  ${InputBaseStyles}
  padding: 0 8px;
  outline: none;
  width: 155px;
`

export const AssetSettings_s = styled.div`
  padding: 15px;
  #codeInput, #nameInput, #addressInput {
    width: 200px;
  }
  #chartDropdown {
    width: 250px;
  }
  textarea {
    border-color: ${Colors.towerGrey};
    border-radius: 2px;
    color: ${Colors.blackPearl};
    font-family: 'Roboto', sans-serif;
    font-size: 14px;
    padding: 8px;
    &:focus {
      outline: 1px solid ${Colors.blackPearl};
    }
  }
`

export const AttributeTable_s = styled(DataTable_s)`
  border-spacing: 15px;
  margin: 10px;
  position: fixed;

  .p-datatable-scrollable-body {
    max-height: calc(100vh - 240px);
  }

  table.p-datatable-scrollable-header-table, table.p-datatable-scrollable-body-table {
    width: auto;
  }

  div.p-paginator {
    position: relative;
    width: 795px;
  }
`
